"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CommonPrefix = {
    type: "structure",
    required: [],
    members: {
        Prefix: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_CommonPrefix.js.map